import React from 'react';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LikeButtonProps {
  isLiked: boolean;
  likeCount: number;
  onToggle: () => void;
  loading?: boolean;
  size?: 'sm' | 'default';
}

export function LikeButton({ 
  isLiked, 
  likeCount, 
  onToggle, 
  loading = false,
  size = 'sm'
}: LikeButtonProps) {
  return (
    <Button
      variant="ghost"
      size={size}
      onClick={onToggle}
      disabled={loading}
      className={cn(
        "flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors",
        isLiked && "text-red-500 hover:text-red-600"
      )}
    >
      <Heart 
        className={cn(
          "w-4 h-4 transition-all duration-200",
          isLiked && "fill-current scale-110"
        )} 
      />
      {likeCount > 0 && (
        <span className="text-sm font-medium">
          {likeCount}
        </span>
      )}
    </Button>
  );
}